import React, {useEffect, useState} from "react";
import {useSelector} from "../../../shared-services/redux-tiny";
import CartButtonsPDP from "./CartButtonsPDP";
import PriceInfoPDP from "./PriceInfoPDP";
import PriceTagPDP from "./PriceTagPDP";
import BottomDrawer from "../../topLayer/bottomDrawer/BottomDrawer";

const CartBlockPDPMobile = (props) => {
  const {className = "", style} = props || {};
  const {bottomDrawer} = useSelector(state => state.topLayer);
  const name = "CartBlockPDPMobile";

  const [product, setProduct] = useState(null);

  useEffect(() => {
    if (bottomDrawer?.name === name && bottomDrawer?.props) {
      setProduct(bottomDrawer.props?.product);
    }

    return () => {
      setProduct(null)
    }
  }, [bottomDrawer]);

  return <BottomDrawer name={name}>
    {product && <div
      className={`
        cart-block-pdp-mobile
        flex
        align-items-center
        gap-10
        justify-content-space-between
        padding-10
        ${className}
      `}
      style={style}
    >
      <PriceTagPDP product={product}/>
      <CartButtonsPDP product={product} style={{flexBasis: "60%", flexGrow: 0}}/>
    </div>}

    {product?.available_to_add_to_cart && <PriceInfoPDP product={product}/>}
  </BottomDrawer>;
};

export default CartBlockPDPMobile;
